const config = {
  production: {
    url: "https://scribesmart.farallonmed.com/",
    apiUrl: "https://scribesmart.farallonmed.com/api/v1/"
  },
  staging: {
    url: "https://scribe-notes.com/",
    // apiUrl: "https://scribe-notes-api.com/api/v1",
    apiUrl: "http://35.203.190.187/api/v1/",
  },
  development: {
    url: "http://localhost:4054/",
    apiUrl: "http://localhost:5025/api/v1/",
  },
};

// Define the environment number
export const env = 2; // 0 for development, 1 for staging, 2 for production

// Map the environment number to the corresponding environment name
const envMapping = ["development", "staging", "production"];

// Get the current environment name based on the env number
const currentEnv = envMapping[env];
// Create host configuration based on the selected environment
const hostConfig = {
  WEB_URL: config[currentEnv]?.url,
  API_URL: config[currentEnv]?.apiUrl

};
// Export hostConfig and intervals together

export { hostConfig };


